export enum EnvironmentName {
  Development = 'development',
  Stage = 'stage',
  Production = 'production',
  Local = 'local',
}

export interface Environment {
  production: boolean;
  envName: EnvironmentName;
  apiHost: string;
  useMocks: boolean;
  reown: ReownEnvironmentConfig;
  networks: ReownAppKitNetworkConfig[];
  /** Deposit asset addresses that require approve(0) before increasing a non-zero allowance. */
  usdtForceApproveAddresses: readonly string[];
}

export interface ReownEnvironmentConfig {
  analytics: boolean;
  enableReconnect: boolean;
  metadata: {
    description: string;
    icons: string[];
    name: string;
    url: string;
  };
  projectId: string;
}

export interface ReownAppKitNetworkConfig {
  chainId: number;
  chainIdHex: `0x${string}`;
  name: string;
}
